// @flow

import React from 'react';
import type { Node } from 'react';
import { ContentAttribute } from 'shared_components/cms/attributes/Content';

import { cmsModuleArtistArtGridTextCls } from 'shared_components/cms/modules/artist/ArtGrid.less';

type ContentArtistTextProps = {
  text?: Object,
};

/**
 * ArtistArtGridText
 *
 * @param {ContentArtistTextProps} props
 * @returns {Node}
 */
export function ArtistArtGridText({ text }: ContentArtistTextProps): Node {
  return text ? (
    <div className={cmsModuleArtistArtGridTextCls}>
      <ContentAttribute plainTextWrapper="p" {...text} />
    </div>
  ) : null;
}
